export const defaultLocalizationNamespaces = [
    "changeFileUploadList",
    "changePasswordForm",
    "changeStatusList",
    "common",
    "companyDetail",
    "companyPage",
    "companyUserSelect",
    "courierDedication",
    "courierDetail",
    "courierFileUploadModal",
    "courierLogTable",
    "courierStatusLogTable",
    "courierMapTab",
    "courierPage",
    "courierResetPasswordModal",
    "courierStatisticsReportPage",
    "courierStatisticsTable",
    "courierStatuses",
    "courierStatusUpdateModal",
    "courierTypes",
    "dailyOrderStatsWidget",
    "datePeriodOptions",
    "dayOff",
    "dayOffStatuses",
    "days",
    "deliveryStatuses",
    "deliveryVerificationOptions",
    "durationStatsWidget",
    "dynamicPriceOptions",
    "forgotPasswordModal",
    "heatMap",
    "hourlyOrderStatsWidget",
    "imageEditorModal",
    "integrations",
    "lastRespondedByStatuses",
    "loginForm",
    "mapCourierStatuses",
    "mapStatisticTitles",
    "mergeOptions",
    "multipleSelect",
    "newCompany",
    "newCourier",
    "newPassword",
    "newRequest",
    "newUser",
    "objectionDetail",
    "objectionStatuses",
    "activationSteps",
    "orderCountStatsWidget",
    "orderDetail",
    "orderPage",
    "orderReportPage",
    "orderSourceStatsWidget",
    "orderStatuses",
    "orderTimeStatsWidget",
    "paymentManagement",
    "paymentMethodStatsWidget",
    "paymentTypes",
    "profilePage",
    "proofModal",
    "proofOfDelivery",
    "reportPage",
    "selectReasons",
    "shiftCompliance",
    "shiftManagement",
    "shiftReportStatuses",
    "shiftScore",
    "shiftSuggestion",
    "singleMarkerMap",
    "slotCourierDedication",
    "slotDetailCard",
    "slotOrderOptions",
    "smsTrackingOptions",
    "statisticsContainer",
    "statisticsPage",
    "stats",
    "subcompanyDetail",
    "textBoxFormModal",
    "tickets",
    "timeRangeOptionsStatistics",
    "transferModal",
    "userAuthorization",
    "userDetail",
    "userPage",
    "userTypes",
    "workTypes",
    "pools",
    "options",
    "courierContracts",
    "pagePermissions",
    "applications"
];
